export default __webpack_public_path__ + "static/media/iamodal.d4b05bfe.svg";